import React from 'react'

import ButtonBase from '../ButtonBase/ButtonBase'
import ButtonContent from '../ButtonContent/ButtonContent'


const SimpleButton = (props) => {
  const { children, title, size, loading, noPadding, ...rest } = props

  return (
    <ButtonBase size={size} {...rest}>
      <ButtonContent {...{ children, title, size, loading, noPadding }} />
    </ButtonBase>
  )
}

SimpleButton.propTypes = {
  ...ButtonBase.propTypes,
  ...ButtonContent.propTypes,
}


export default SimpleButton
